import React, { useState, useEffect } from 'react';
import { useLanguage } from '../contexts/LanguageContext';
import Navigation from '../components/Navigation';
import HeroSection from '../components/HeroSection';
import AboutSection from '../components/AboutSection';
import ServicesSection from '../components/ServicesSection';
import TechniquesSection from '../components/TechniquesSection';
import TestimonialsSection from '../components/TestimonialsSection';
import AccessibilitySection from '../components/AccessibilitySection';
import LocationSection from '../components/LocationSection';
import Footer from '../components/Footer';

const LandingPage = () => {
  const { language } = useLanguage();
  const [isLoaded, setIsLoaded] = useState(false);

  useEffect(() => {
    setIsLoaded(true);
  }, []);

  return (
    <div className="min-h-screen bg-cream" lang={language}>
      {/* Skip Link for Accessibility */}
      <a 
        href="#main-content" 
        className="skip-link"
        data-testid="skip-link"
      >
        {language === 'en' ? 'Skip to main content' : 'Chuyển đến nội dung chính'}
      </a>

      {/* Subtle grain texture overlay */}
      <div className="grain-overlay" aria-hidden="true"></div>

      {/* Navigation */}
      <Navigation />

      {/* Main Content */}
      <main id="main-content" role="main">
        <HeroSection isLoaded={isLoaded} />
        <AboutSection />
        <ServicesSection />
        <TechniquesSection />
        <TestimonialsSection />
        <AccessibilitySection />
        <LocationSection />
      </main>

      {/* Footer */}
      <Footer />
    </div>
  );
};

export default LandingPage;
